module.exports = __webpack_public_path__ + "static/defending-jacob-f6ba9839cb90dfd686aad43e4b0f69f7.jpg";